import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const BRIDGE_IMG = '/sovereign-bridge.png';

export default function GlobalBridge() {
  return (
    <div>
      <section className="relative min-h-[70vh] flex items-end overflow-hidden">
        <img src={BRIDGE_IMG} alt="Global Bridge" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/60 to-transparent" />
        <div className="relative z-10 px-6 md:px-12 lg:px-24 pb-20 w-full">
          <div className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-6">Global Bridge</div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extralight leading-[1] tracking-tight max-w-5xl">
            The diaspora<br />
            <span className="font-display italic text-[#D4AF37]">capital corridor.</span>
          </h1>
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-24 py-20 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
        <div className="md:col-span-4">
          <div className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-6">Rescue Brief</div>
          <h2 className="text-3xl md:text-4xl font-extralight leading-tight tracking-tight">
            One vessel. Two<br />continents.<br />One commander.
          </h2>
        </div>
        <div className="md:col-span-8 space-y-8 text-[#F5F5F5] font-light leading-relaxed">
          <p className="text-lg md:text-xl">
            The Nigeria-to-US real estate pipeline has been informal for two decades —
            run on WhatsApp threads, trust networks, and currency arbitrage. It moves billions,
            and it loses millions in friction, fraud, and forfeit deposits every quarter.
          </p>
          <p className="text-base text-[#A3A3A3]">
            Sovereign Heritage Command is the first vessel built to <span className="text-[#F5F5F5] italic">command</span> that
            pipeline — not service it. Mercy is positioned as the trans-atlantic admiral: every
            asset is vetted from Lagos to Honolulu under a single chain-of-custody, every investor
            is identity-anchored under sovereign KYC, and every valuation is shielded by AI that
            understands both the Naira spread and the Pacific premium.
          </p>
          <p className="text-base text-[#A3A3A3]">
            This is not a marketplace. It is a private command structure with public-facing addresses —
            a Lineage Law vessel running the diaspora's most valuable corridor under a 75/25 admiral split.
          </p>
        </div>
      </section>

      <section className="bg-[#0A0A0A] border-y border-[#D4AF37]/15">
        <div className="px-6 md:px-12 lg:px-24 py-20 grid grid-cols-1 md:grid-cols-3 gap-12">
          {[
            { eyebrow: 'I · Sourcing', title: 'Banana Island to Wailea', body: 'Every asset is hand-selected from the apex Lagos addresses (Banana Island, Ikoyi, Maitama) and the Pacific\'s most coveted shores (Maui, Oahu, Kohala). No public MLS exposure.' },
            { eyebrow: 'II · Translation', title: 'The Naira-Dollar Mirror', body: 'Properties are dual-pegged: Naira valuation for local liquidity, Dollar valuation for diaspora capital. The AI Valuation Shield translates both in real time.' },
            { eyebrow: 'III · Settlement', title: 'Identity Before Capital', body: 'No transaction begins without identity-anchored boarding. Mercy\'s office issues the seal. Capital flows only after the admiral confirms the corridor is clear.' },
          ].map((c, i) => (
            <div key={i} className="border-t border-[#D4AF37]/15 pt-8">
              <div className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-4">{c.eyebrow}</div>
              <h3 className="text-2xl font-light leading-tight tracking-tight mb-4 text-[#F5F5F5]">{c.title}</h3>
              <p className="text-sm text-[#A3A3A3] font-light leading-relaxed">{c.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="px-6 md:px-12 lg:px-24 py-24 text-center">
        <div className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-6">The Doctrine</div>
        <p className="font-display text-3xl md:text-5xl lg:text-6xl text-[#F5F5F5] italic leading-[1.1] max-w-5xl mx-auto mb-12">
          "Heritage is the only currency<br />that survives currency."
        </p>
        <div className="text-[10px] tracking-[0.4em] uppercase text-[#A3A3A3]">— Mercy, Commander</div>

        <div className="mt-16">
          <Link to="/boarding" className="btn-sovereign">
            Request Boarding <ArrowUpRight size={16} strokeWidth={1.5} />
          </Link>
        </div>
      </section>
    </div>
  );
}
